import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, Flex, styled } from '@withjoy/joykit';

export const StyledChecklistLoader = styled(Flex)``;
const checklistLoaderStyles: StyleSystemProps = {
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

export const StyledChecklistWrapper = styled(Box)``;
export const StyledChecklistSectionWrapper = styled(Box)``;

export const StyledDivider = styled(Box)``;
const dividerStyles: StyleSystemProps = {
  width: '100%',
  borderBottom: '1px solid',
  borderColor: 'mono3',
};

export const styles = {
  divider: dividerStyles,
  checklistLoader: checklistLoaderStyles,
};
